import React from 'react';
import { motion } from 'framer-motion';
export function ContactPage() {
  return <div className="min-h-screen bg-sovereign-navy flex items-center justify-center relative overflow-hidden" data-id="element-178">
      {/* Subtle spotlight effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-sovereign-gold/5 rounded-full blur-3xl" data-id="element-179" />

      <div className="container mx-auto px-6 text-center relative z-10" data-id="element-180">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-181">
          <span className="text-gray-500 uppercase tracking-[0.3em] text-xs mb-6 block" data-id="element-182">
            Concierge Service
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-white mb-12" data-id="element-183">
            We await your correspondence.
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="inline-block" data-id="element-184">
          <a href="mailto:hello@sovereigntims.com" className="text-2xl md:text-4xl text-sovereign-gold font-light hover:text-white transition-colors duration-500 border-b border-sovereign-gold/30 pb-2 hover:border-white/30" data-id="element-185">
            hello@sovereigntims.com
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 0.8
      }} className="mt-12 text-gray-500 font-light text-sm" data-id="element-186">
          Response time: Within 24 hours
        </motion.p>
      </div>
    </div>;
}